import './styles.scss';
import React from 'react';
import {Form, Input} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import Button from "../../common/Button/Button";

const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: {span: 24, offset: 0},
        sm: {span: 24, offset: 0},
    },
};

interface Props {
    name:string,
    form:any,
}

function AlternateEmailsFormList({name, form}:Props) {
    return (
        <Form.List name={name}>
            {(fields, {add, remove}, {errors}) => (
                <>
                    {fields.map((field, index) => (
                        <Form.Item
                            {...formItemLayoutWithOutLabel}
                            required={false}
                            key={field.key}
                            style={{width: '100%'}}
                        >
                            <Form.Item
                                {...field}
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input an email or delete this field.",
                                    },
                                ]}
                                noStyle
                            >
                                <div className='alternate-email-single'>
                                    <Input size='large' placeholder="Alternate email" value={form.getFieldValue(field.key)}/>
                                    <MinusCircleOutlined
                                        className="dynamic-delete-button"
                                        onClick={() => remove(field.name)}
                                    />
                                </div>
                            </Form.Item>

                        </Form.Item>
                    ))}
                    <Form.Item>
                        <Button
                            onClick={() => add()}
                            style={{width: '60%'}}
                            icon={<PlusOutlined/>}
                            color="orange"
                        >
                            Add Alternate Email
                        </Button>
                        <Form.ErrorList errors={errors}/>
                    </Form.Item>
                </>
            )}
        </Form.List>
    )
}

export default AlternateEmailsFormList;